/**
 * @file Automatically generated by barrelsby.
 */

export * from './loading-indicator.component';
